import { CaretRightOutlined, LockOutlined } from '@ant-design/icons';
import { Dropdown, Skeleton } from 'antd';
import { cloneElement, useState } from 'react';
import AC from '../../../components/AccessControl';
import styles from './Menu.module.scss';
import { useRouter } from 'next/router';
const MenuIcon = ({
  color,
  url,
  title,
  isCurrent,
  disabled
}) => {
  const [R, G, B] = color.match(/[0-9A-F]{2}/gi).map(hex => parseInt(hex, 16) / 255);
  const id = `toolkit-item-icon-${color.replace('#', '')}`;
  const style = {
    width: '100%',
    height: '100%'
  };
  if (!isCurrent) {
    style.filter = `url(#${id})`;
  }
  return <figure title={title} className={`menu-item-icon ${disabled ? 'disabled' : ''}`} data-sentry-component="MenuIcon" data-sentry-source-file="Menu.jsx">
      <svg viewBox="0 0 0 0" width="0" height="0" data-sentry-element="svg" data-sentry-source-file="Menu.jsx">
        <filter id={id} colorInterpolationFilters="sRGB" data-sentry-element="filter" data-sentry-source-file="Menu.jsx">
          <feColorMatrix type="matrix" values={`
              ${R}    0    0 0 0
                 0 ${G}    0 0 0
                 0    0 ${B} 0 0
                 0    0    0 1 0
            `} data-sentry-element="feColorMatrix" data-sentry-source-file="Menu.jsx" />
        </filter>
      </svg>
      <img src={url} alt={title} style={style} />
    </figure>;
};
export const MenuLink = ({
  page: {
    type,
    slug,
    name
  },
  color,
  iconURL,
  menuTitle,
  isCollapsed
}) => {
  const {
    pathname,
    query
  } = useRouter();
  const href = {
    pathname: `/toolkits/${type}/[slug]`,
    query: {
      slug
    }
  };
  const isCurrent = pathname === href.pathname && query.slug === slug;
  const label = <div className={`${styles.menuLinkItem} ${isCurrent ? styles.current : ''}`} style={{
    backgroundColor: {
      color
    }
  }}>
      <MenuIcon color={color} url={iconURL} title={name} isCurrent={isCurrent} />
      <div className="menu-item-label">{menuTitle}</div>
    </div>;
  return <AC.Link href={href} label={label} ifCant={cloneElement(label, {
    disabled: true
  })} data-sentry-element="unknown" data-sentry-component="MenuLink" data-sentry-source-file="Menu.jsx" />;
};
export const MenuDropdown = ({
  menu: {
    title,
    pages
  },
  color,
  iconURL,
  menuTitle,
  isCollapsed
}) => {
  const [pagesAccessibility, setPagesAccessibility] = useState({});
  const {
    pathname,
    query
  } = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const links = pages.map(({
    type,
    slug,
    name,
    linkName
  }) => {
    const href = {
      pathname: `/toolkits/${type}/[slug]`,
      query: {
        slug
      }
    };
    const key = `${type}:${slug}`;
    return {
      accessible: pagesAccessibility[key],
      current: pathname === href.pathname && query.slug === slug,
      key: key,
      label: <AC.Link href={href} label={linkName || name} onChecked={accessible => setPagesAccessibility(prev => ({
        ...prev,
        [key]: accessible
      }))} />
    };
  });
  const itemsToCheck = links.filter(e => e.accessible == null);
  if (itemsToCheck.length > 0) {
    return <div className={styles.menuLinkItem}>
        <Skeleton.Button />
        {itemsToCheck.map(({
        key,
        label
      }) => <div key={key} children={label} style={{
        display: 'none'
      }} />)}
      </div>;
  }
  const items = links.filter(e => e.accessible);
  const disabled = items.length === 0;
  const selectedKeys = items.filter(i => i.current).map(i => i.key);
  const isCurrent = selectedKeys.length > 0;
  const button = <div className={`${styles.menuLinkItem} ${isCurrent ? styles.current : ''} ${disabled ? styles.disabled : ''} ${isOpen ? styles.open : ''}`} key={title} style={{
    color: isCurrent ? 'white' : color,
    backgroundColor: isCurrent ? color : isOpen ? `${color}60` : 'transparent'
  }}>
      <MenuIcon color={color} url={iconURL} title={title} isCurrent={isCurrent} disabled={disabled} />
      {!isCollapsed ? <div className={styles.menuItemLabel}>{menuTitle}</div> : null}
      {!disabled ? <CaretRightOutlined /> : <LockOutlined />}
    </div>;
  return disabled ? button : <Dropdown menu={{
    selectedKeys,
    items,
    forceSubMenuRender: true
  }} overlayClassName={styles.menuDropdown} overlayStyle={{
    borderLeft: `solid 3px ${color}`,
    borderRadius: '0.5rem'
  }} trigger={['click']} children={<a children={button} />} placement="rightTop" onOpenChange={open => setIsOpen(open)} />;
};